export var FeatureTypes;
(function (FeatureTypes) {
    FeatureTypes["virtualPoints"] = "virtualPoints";
    FeatureTypes["elimination"] = "elimination";
    FeatureTypes["goal"] = "goal";
    FeatureTypes["finishingConditions"] = "finishingConditions";
    FeatureTypes["sportLeague"] = "sportLeague";
})(FeatureTypes || (FeatureTypes = {}));
